import { useEffect, useState } from "react";
import { useOutletContext, useParams } from "react-router-dom";
import { Locale } from "@dealer-center/ddc-core-utils";
import type { ControlcenterAPIInterfaceExternal } from "@dealer-center/ddc-pages-controlcenter-interface";
import type { decodedJwtAndPermissions } from "@dealer-center/ddc-api-user-interface";
import { useWelcomeAPIInterface } from "@dealer-center/ddc-pages-welcome-fetch";
import { SupportContactsSection } from "./components/SupportContactsSection";
import { Box } from "@dealer-center/core-components";
import { MessagePage } from "@dealer-center/core-custom-components";
import LABELS from "./labels.json";

export const YourTeam = () => {
  const [locale, setLocale] = useState("en-US");
  const { asUser } = useParams<{
    asUser: string;
  }>();
  const { ccUserInfo } = useOutletContext<{
    ccUserInfo: ControlcenterAPIInterfaceExternal;
    userEntity: decodedJwtAndPermissions;
  }>();
  const { data, isLoading, isError } = useWelcomeAPIInterface({
    accountId: ccUserInfo?.accountId || "",
    asUserId: asUser || ""
  });

  Locale.setLabelsOnce(LABELS);

  // Set body background color and hide horizontal overflow
  useEffect(() => {
    const originalBgColor = document.body.style.backgroundColor;
    const originalOverflowX = document.body.style.overflowX;
    document.body.style.backgroundColor = "white";
    document.body.style.overflowX = "hidden";

    return () => {
      document.body.style.backgroundColor = originalBgColor;
      document.body.style.overflowX = originalOverflowX;
    };
  }, []);

  useEffect(() => {
    const newLocale = Locale.getLocale();

    if (locale !== newLocale) {
      Locale.change(newLocale);
      setLocale(newLocale);
    }
  }, [locale]);

  if (isLoading) {
    return (
      <MessagePage
        actionName="Loading YourTeam page"
        message={String(Locale.getText("LOADING_YOUR_TEAM_MSG"))}
      />
    );
  }

  if (isError) {
    return <div>{String(Locale.getText("ERROR_YOUR_TEAM"))}</div>;
  }

  return (
    <Box
      sx={{
        backgroundColor: "white",
        display: "flex",
        justifyContent: "center"
      }}
    >
      <Box
        className="content-container"
        sx={{
          width: "100%",
          maxWidth: 973,
          backgroundColor: "white"
        }}
      >
        {/* Support Contacts Section */}
        <SupportContactsSection
          labelLinks={data?.labelLinks}
          marginBottom="20px"
          marginTop="20px"
          singleViewOfCustomer={data?.singleViewOfCustomer}
          supportContacts={data?.supportContacts}
        />
      </Box>
    </Box>
  );
};
